import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";

import { LanguageProvider } from "./i18n/LanguageContext";
import Header from "./components/site/Header";
import Hero from "./components/site/Hero";
import About from "./components/site/About";
import Features from "./components/site/Features";
import Products from "./components/site/Products";
import Process from "./components/site/Process";
import Quality from "./components/site/Quality";
import Gallery from "./components/site/Gallery";
import EditorialMarquee from "./components/site/EditorialMarquee";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";
import WhatsAppFloat from "./components/site/WhatsAppFloat";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    document.title = "Tropical Vanilla Co. — Premium Indonesian Vanilla Beans";

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App bg-cream">
        <Header />
        <main>
          <Hero />
          <About />
          <Features />
          <Products />
          <Process />
          <Quality />
          <Gallery />
          <EditorialMarquee />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </LanguageProvider>
  );
}

export default App;
